<template>
  <div class="max-w-2xl md:max-w-5xl mx-auto px-2 sm:px-10">
    <slot></slot>
  </div>
</template>
